import React from "react"
import Error from "./Error.js"
import Warn from "./Warn.js"
import { FieldIndicator } from "../Indicators"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const CheckboxLabel = styled.label`font-size: 1rem;`

const CheckBox = styled.input`
  display: inline-block;
  margin-right: 0.75rem;
`

const CheckboxField = ({
  input,
  data,
  name,
  meta: { touched, error, warning, asyncValidating },
  labelText
}) => {
  return (
    <div>
      <Wrapper>
        {asyncValidating ? <FieldIndicator /> : ""}
        <CheckboxLabel htmlFor={name}>
          <CheckBox
            {...input}
            type="checkbox"
            error={touched && error}
            name={name}
            checked={input.value}
          />
          {labelText}
        </CheckboxLabel>
      </Wrapper>
      {touched &&
        ((error &&
          <Error>
            {error}
          </Error>) ||
          (warning &&
            <Warn>
              {warning}
            </Warn>))}
    </div>
  )
}

export default CheckboxField



// WEBPACK FOOTER //
// ./src/UI/Form/CheckboxField.js